import {
    CadNextRelatedDataLocationQuery,
    CadNextRelatedDataVehicleQuery,
    EventPanelFormType,
    RelatedDataPersonQuery,
} from '@mark43/cad-api';
import { getSubPremiseDtosFromLocation } from '../../../event-panel/tabs/related-data/utils';
import { SelectedLocation } from '../../../event-panel/tabs/hooks/use-selected-location';
import { compact, uniq } from 'lodash';

const getRelatedDataPersonQuery = (
   persons: EventPanelFormType['involvedPersons'] | EventPanelFormType['reportingParties']
): RelatedDataPersonQuery[] => {
    return persons.flatMap((person) => {
        if (
            person.firstName ||
            person.lastName ||
            person.dateOfBirth ||
            person.driversLicenseNumber ||
            person.phoneNumber
        ) {
            return [
                {
                    firstName: person.firstName ?? undefined,
                    lastName: person.lastName ?? undefined,
                    dateOfBirth: person.dateOfBirth ?? undefined,
                    driversLicenseNumber: person.driversLicenseNumber ?? undefined,
                    phoneNumber: person.phoneNumber ?? undefined,
                },
            ];
        } else {
            return [];
        }
    });
};

const getRelatedDataVehicleQuery = (
    vehicles: EventPanelFormType['vehicles']
): CadNextRelatedDataVehicleQuery[] => {
    return vehicles.flatMap((vehicle) => {
        if (vehicle.vinNumber || vehicle.plateNumber || vehicle.stateOption?.value) {
            return [
                {
                    registrationStateAttrId: vehicle.stateOption?.value,
                    vinNumber: vehicle.vinNumber ?? undefined,
                    tag: vehicle.plateNumber ?? undefined,
                },
            ];
        } else {
            return [];
        }
    });
};

const getRelatedDataLocationQuery = (
    location: SelectedLocation | null,
    subPremise: string | null
): CadNextRelatedDataLocationQuery | undefined => {
    return location
        ? {
              country: location.country,
              crossStreet1: location.crossStreet1,
              crossStreet2: location.crossStreet2,
              locality: location.locality,
              postalCode: location.postalCode,
              rangeName: location.rangeName,
              streetAddress: location.streetAddress,
              subPremise: subPremise ?? undefined,
              subPremiseDtos: getSubPremiseDtosFromLocation(location),
          }
        : undefined;
};

export const getRelatedDataQueriesForEntityPanel = (
    persons: EventPanelFormType['involvedPersons'],
    vehicles: EventPanelFormType['vehicles'],
    location: SelectedLocation | null,
    subPremise: string | null
) => {
    return {
        vehicleQueries: getRelatedDataVehicleQuery(vehicles),
        personQueries: getRelatedDataPersonQuery(persons),
        relatedDataLocationQuery: getRelatedDataLocationQuery(location, subPremise),
        phoneNumbers: uniq(compact(persons.map((entity) => entity.phoneNumber))),
    };
};
